module.exports = __webpack_public_path__ + "c32817f90310d49d586ee5a3a1c815c4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/delete/delete-label.html
// module id = 2183
// module chunks = 0